import React from "react";
import { Instagram, Linkedin, Mail } from "lucide-react";
import BLabsLogo from "./BLabsLogo";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { label: "Om oss", href: "#about" },
      { label: "Hvordan det fungerer", href: "#how-it-works" },
      { label: "FAQ", href: "#faq" },
    ],
    services: [
      { label: "For bedrifter", href: "#benefits" },
      { label: "Bli partner", href: "#work-with-us" },
      { label: "Kjøp maskin", href: "#buy" },
    ],
  };

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer
      className="bg-[#0A0A0A] border-t border-white/5 py-16"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <a
              href="#"
              className="inline-block mb-6"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <BLabsLogo size="default" />
            </a>
            <p className="text-[#A1A1AA] mb-6 max-w-sm">
              Norges ledende leverandør av powerbank-stasjoner for sosiale
              møteplasser. Ingen skal gå tom for strøm.
            </p>

            {/* Social Links */}
            <div className="flex gap-4">
              <a
                href="mailto:brienlabs.hq@gmail.com"
                className="w-10 h-10 bg-[#121212] border border-white/10 rounded-lg flex items-center justify-center text-[#A1A1AA] hover:text-[#FFD84D] hover:border-[#FFD84D]/30 transition-all"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-[#121212] border border-white/10 rounded-lg flex items-center justify-center text-[#A1A1AA] hover:text-[#FFD84D] hover:border-[#FFD84D]/30 transition-all"
                data-testid="footer-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-[#121212] border border-white/10 rounded-lg flex items-center justify-center text-[#A1A1AA] hover:text-[#FFD84D] hover:border-[#FFD84D]/30 transition-all"
                data-testid="footer-linkedin"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links - Company */}
          <div>
            <h4 className="text-white font-semibold mb-4 font-['Outfit']">
              Selskap
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-[#A1A1AA] hover:text-[#FFD84D] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Links - Services */}
          <div>
            <h4 className="text-white font-semibold mb-4 font-['Outfit']">
              Tjenester
            </h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-[#A1A1AA] hover:text-[#FFD84D] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-[#A1A1AA]">
            © {currentYear} B-Labs. Alle rettigheter reservert.
          </p>
          <p className="text-sm text-[#FFD84D] font-medium font-['Pacifico']">
            Stay powered
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
